import Marquee from "react-fast-marquee";
import { ArrowUp } from "lucide-react";
import { Reveal } from "./motion";

export const CloseCTA = ({ scrollToForm }) => {
  return (
    <section className="relative overflow-hidden bg-ink py-28 md:py-40" data-testid="close-section">
      {/* Editorial marquee behind */}
      <div className="pointer-events-none absolute inset-0 flex flex-col justify-center gap-4 opacity-90">
        <Marquee speed={40} gradient={false}>
          <span className="marquee-outline px-6 font-display text-[10vw] font-black uppercase leading-none tracking-tight">
            You Are Already Dope&nbsp;·&nbsp;Listen First&nbsp;·&nbsp;Build Real Relationships&nbsp;·&nbsp;
          </span>
        </Marquee>
        <Marquee speed={40} direction="right" gradient={false}>
          <span className="marquee-outline px-6 font-display text-[10vw] font-black uppercase leading-none tracking-tight">
            No Script&nbsp;·&nbsp;No Pitch&nbsp;·&nbsp;No Elevator Pitch&nbsp;·&nbsp;Go Deeper&nbsp;·&nbsp;
          </span>
        </Marquee>
      </div>

      <div className="relative z-10 mx-auto max-w-3xl px-5 text-center md:px-10">
        <Reveal>
          <h2 className="font-display text-5xl font-black uppercase leading-none tracking-tighter text-white sm:text-6xl lg:text-7xl" data-testid="close-headline">
            You Are <span className="text-acid">Already</span> Dope.
          </h2>
        </Reveal>
        <Reveal delay={0.08}>
          <p className="mt-6 font-display text-xl font-extrabold uppercase tracking-tight text-cyan md:text-2xl">
            Dope people build dope relationships.
          </p>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mx-auto mt-8 max-w-xl text-lg leading-relaxed text-white/80" data-testid="close-body">
            You did not need an elevator pitch. You needed permission to be present, make the conversation
            about them, listen, keep your answer simple, and follow through. The habit is the practice. Do
            it again at the next event.
          </p>
        </Reveal>
        <Reveal delay={0.24}>
          <div className="mt-10 flex flex-col items-center gap-5">
            <div className="flex flex-col items-center gap-4 sm:flex-row">
              <button
                onClick={scrollToForm}
                data-testid="close-cta-button"
                className="group inline-flex items-center gap-2.5 rounded-none border-2 border-acid bg-acid px-9 py-4 font-mono text-sm font-bold uppercase tracking-[0.16em] text-ink transition-transform duration-200 hover:-translate-y-1 focus:outline-none focus:ring-4 focus:ring-cyan"
              >
                Send it to me
                <ArrowUp className="h-4 w-4 transition-transform duration-200 group-hover:-translate-y-1" strokeWidth={2.5} />
              </button>
            </div>
            <p className="font-display text-2xl font-black uppercase tracking-widest text-white" data-testid="close-tagline">
              Let&apos;s Get It!
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
